import React from "react";
import { AlertCircle, ArrowRight, CheckCircle2 } from "lucide-react";
import "./Contact.css";
import { useContactForm } from "./contact.functions";

export default function Contact() {
  const {
    formData,
    submitting,
    submitStatus,
    handleInputChange,
    handleSubmit,
    isFormValid,
  } = useContactForm();

  return (
    <div className="contact">
      <div className="contact__container">
        <main className="contact__form">
          <div className="contact__formCard">
            {/* Form header */}
            <h2 className="contact__formTitle">Contact Us</h2>

            <form onSubmit={handleSubmit} className="contact__formFields">
              {/* Form fields */}

              <div className="contact__field">
                <label htmlFor="email" className="contact__label">
                  Email <span className="contact__required">*</span>
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="your.email@example.com"
                  required
                  disabled={submitting}
                  className="contact__input"
                />
              </div>

              <div className="contact__field">
                <label htmlFor="subject" className="contact__label">
                  Subject
                </label>
                <input
                  id="subject"
                  name="subject"
                  type="text"
                  value={formData.subject}
                  onChange={handleInputChange}
                  placeholder="What is this regarding?"
                  disabled={submitting}
                  className="contact__input"
                />
              </div>

              <div className="contact__field">
                <label htmlFor="message" className="contact__label">
                  Message <span className="contact__required">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows="8"
                  required
                  disabled={submitting}
                  className="contact__textarea"
                />
              </div>

              {/* Submission feedback */}
              {submitStatus === "success" && (
                <div className="contact__alert contact__alert--success">
                  <CheckCircle2 className="contact__alertIcon" aria-hidden="true" />
                  <div>
                    <strong>Message sent successfully!</strong>
                    <p>We appreciate your message.</p>
                  </div>
                </div>
              )}

              {submitStatus && submitStatus !== "success" && (
                <div className="contact__alert contact__alert--error">
                  <AlertCircle className="contact__alertIcon" aria-hidden="true" />
                  <div>
                    <strong>Oops! Something went wrong.</strong>
                    <p>{submitStatus}</p>
                  </div>
                </div>
              )}

              {/* Submit action */}
              <button
                type="submit"
                disabled={!isFormValid || submitting}
                className="contact__submitBtn"
              >
                {submitting ? (
                  <>
                    <span className="contact__spinner" />
                    Sending...
                  </>
                ) : (
                  <>
                    <span>Send Message</span>
                    <ArrowRight className="contact__submitIcon" aria-hidden="true" />
                  </>
                )}
              </button>
            </form>
          </div>
        </main>
      </div>
    </div>
  );
}
